import * as React from 'react';
import style from './ServiceKitItem.module.scss';

export const ServiceKitItem = () => {
    return <></>;
};
